import React from "react";
import "./ArticlePreviewListItem.css";
import ArticlePreviewParagraphItem from "../ArticlePreviewParagraphItem/ArticlePreviewParagraphItem";
import ArticlePreviewSecTitleItem from "../ArticlePreviewSecTitleItem/ArticlePreviewSecTitleItem";
import ArticlePreviewSepItem from "../ArticlePreviewSepItem/ArticlePreviewSepItem";
import ArticlePreviewQuoteItem from "../ArticlePreviewQuoteItem/ArticlePreviewQuoteItem";
import ArticlePreviewImageItem from "../ArticlePreviewImageItem/ArticlePreviewImageItem";
import ArticlePreviewVideoItem from "../ArticlePreviewVideoItem/ArticlePreviewVideoItem";
import ArticlePreviewAudioItem from "../ArticlePreviewAudioItem/ArticlePreviewAudioItem";
import ArticlePreviewGalleryItem from "../ArticlePreviewGalleryItem/ArticlePreviewGalleryItem";
import ArticlePreviewMosaicItem from "../ArticlePreviewMosaicItem/ArticlePreviewMosaicItem";
import ArticlePreviewPrefaceItem from "../ArticlePreviewPrefaceItem/ArticlePreviewPrefaceItem";
import ArticlePreviewSecSubtitleItem from "../ArticlePreviewSecSubtitleItem/ArticlePreviewSecSubtitleItem";

import {
  ACSTYPE_SEC_TITLE,
  ACSTYPE_PARAGRAPH,
  ACSTYPE_QUOTE,
  ACSTYPE_IMAGE,
  ACSTYPE_VIDEO,
  ACSTYPE_AUDIO,
  ACSTYPE_SEP,
  ACSTYPE_GALLERY,
  ACSTYPE_MOSAIC,
  ACSTYPE_PREFACE,
  ACSTYPE_SEC_SUBTITLE
} from "../../model/ACSTypes";

class ArticlePreviewListItem extends React.Component {
  render() {
    const { item, previousItem } = this.props;

    switch (item.styleType) {
      case ACSTYPE_SEC_TITLE:
        return <ArticlePreviewSecTitleItem item={item} />;
      case ACSTYPE_PARAGRAPH:
        return <ArticlePreviewParagraphItem item={item} />;
      case ACSTYPE_QUOTE:
        return <ArticlePreviewQuoteItem item={item} />;
      case ACSTYPE_IMAGE:
        return <ArticlePreviewImageItem item={item} />;
      case ACSTYPE_VIDEO:
        return <ArticlePreviewVideoItem item={item} />;
      case ACSTYPE_AUDIO:
        return <ArticlePreviewAudioItem item={item} />;
      case ACSTYPE_SEP:
        return <ArticlePreviewSepItem item={item} />;
      case ACSTYPE_GALLERY:
        return <ArticlePreviewGalleryItem item={item} />;
      case ACSTYPE_MOSAIC:
        return <ArticlePreviewMosaicItem item={item} />;
      case ACSTYPE_PREFACE:
        return <ArticlePreviewPrefaceItem item={item} />;
      case ACSTYPE_SEC_SUBTITLE:
        return (
          <ArticlePreviewSecSubtitleItem
            item={item}
            previousItem={previousItem}
          />
        );
      default:
        return null;
    }
  }
}

export default ArticlePreviewListItem;
